import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import 'hammerjs';
import { LoggerService } from './app/service/utils/logger.service';

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => LoggerService.error("Error: ", err));
